// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3LZtq","inputWrap":"styles_inputWrap__3ij-s","input":"styles_input__1jV1p"};